module.exports = __webpack_public_path__ + "static/media/Public_07.bd9d5029.jpg";